import { combineReducers } from "redux";
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import RegisterReducer from "./auth/register/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ResetPasswordReducer from "./auth/resetPassword/reducer";
import VerifyCodeReducer from "./auth/verifyCode/reducer";
import ProfileReducer from "./auth/profile/reducer";
import VehicleReducer from "./vehicleManagement/reducer";
import MaintenanceReducer from "./maintenance/reducer";
import RolesReducer from "./rolesAndPermission/reducer";
import TripReducer from "./tripsDetails/reducer";
import UserManagement from "./userManagement/reducer";
import SalaryReducer from "./salaryManagement/reducer";
import DashboardReducer from "./adminDashboardDetails/reducer";
import TripDashboard from "./tripDashboardDetails/reducer";
import RevenueAndExpensesSlice from "./adminDashboardRevenus-Expense/reducer";
import RealTimeTripSlice from "./realTimeTripDetail/reducer";
import DriverManagement from "./driverManagement/reducer";
import MaintenanceCategoryReducer from "./maintenanceCategory/reducer";
import insuranceCategoryReducer from "./insuranceCategory/reducer";
import vehicleTypeReducer from "./vehicleTypeCategory/reducer";
import insuranceSlice from "./insurance/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Register: RegisterReducer,
  Account: AccountReducer,
  forgetPassword: ForgetPasswordReducer,
  ResetPassword: ResetPasswordReducer,
  VerifyCode: VerifyCodeReducer,
  Profile: ProfileReducer,
  Vehicle: VehicleReducer,
  Maintenance: MaintenanceReducer,
  Roles: RolesReducer,
  Trips: TripReducer,
  Salary: SalaryReducer,
  UsersManagement: UserManagement,
  Dashboard: DashboardReducer,
  TripDashboard: TripDashboard,
  RevenueAndExpenses: RevenueAndExpensesSlice,
  RealTimeTrip: RealTimeTripSlice,
  DriverManagementSlice: DriverManagement,
  MaintenanceCategory: MaintenanceCategoryReducer,
  InsuranceCategory: insuranceCategoryReducer,
  VehicleType: vehicleTypeReducer,
  Insurance: insuranceSlice,
});

export default rootReducer;
